// extracted by mini-css-extract-plugin
module.exports = {"sliderThumb":"ReferralDeposit_sliderThumb__Qwysu","sliderBar":"ReferralDeposit_sliderBar__b_Gav","sliderTrack":"ReferralDeposit_sliderTrack___a2rB"};